export const formatMoney = (total: string, isSum = false) => {
  const amount = parseInt(total);

  if (!amount) {
    return '0.00';
  }

  const formatter = new Intl.NumberFormat('uz-UZ', {
    style: 'currency',
    currency: 'UZS',
    minimumFractionDigits: 2,
  });

  const amountInSum = isSum ? amount : amount / 100;

  // Use the built-in Intl.NumberFormatPart type
  const parts: Intl.NumberFormatPart[] = formatter.formatToParts(amountInSum);

  // Build the custom formatted string
  return parts
    .map((part) => {
      if (part.type === 'currency') {
        return '';
      }
      if (part.type === 'group') {
        return ' ';
      }
      return part.value;
    })
    .join('')
    .trim();
};
